<template>
  <div class="creek-shows-container">
    <creek-shows-nav :shows-nav-text="showsNavText" page-selected="calendar"></creek-shows-nav>
    <div class="creek-schedule-container" v-html="html">
    </div>
    <div v-if="!html" v-html="Creek.config.shows.router.loadingHTML"></div>
  </div>
</template>

<script type="text/javascript">

import mixins from '../util/mixins';
import util from '../util/util';
import lang from '../lang/eng';
import JSONP from 'jsonp';

import CreekShowsNav from './ShowsNav';

export default { 
  name: 'creek-page-shows-calendar',
  mixins: [mixins.routes],
  components: {
    'creek-shows-nav': CreekShowsNav,
  },
  data () { 
    return { 
      html: null, 
      title: null,
      showsNavText: lang.schedule,
    } 
  },
  created () {
    this.Creek.debug.log("Calendar Created.");
    this.fetchData();
  },
  methods: {
    fetchData () {

      this.Creek.debug.log("Loading Calendar.");

      //Get data from schedule if it's already been retrieved
      if (!this.html) {
        var _this = this;

        var URL = this.Creek.config.content.baseURLForAPI 
          + "/shows/schedule?json_wrap=1&external=1&external_complete=1";

        JSONP(URL, null, function (err, data) {
          if(err){
            _this.Creek.debug.log(err);
          }
          _this.html = _this.Creek.util.fixLinks(data.html)
          _this.title = data.title;
          //TODO: Update parent Creek options
        });
      }
      this.setTitle("Shows Calendar");
      this.swapPageClass("shows-calendar");
    }
  }
}

</script>